if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat(['data-trigger-open', 'data-repeat-open']);
      }

      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        this.triggerOpen = this.dataset.triggerOpen;
        this.repeatOpen = this.dataset.repeatOpen;

        this.cookieName = 'hypertheme:popup';
        this.sessionKey = 'hypertheme:pageviews';

        this.minTime = 8000;
        this.scrollPercent = 0.35;

        this.timePassed = false;
        this.scrolledEnough = false;
        this.pageViewedEnough = false;
        this.opened = false;

        window.FoxTheme.DOMready(this.handleOpen.bind(this));
      }

      prepareToShow() {
        super.prepareToShow();
        this.setRepeatOpen();
      }

      handleOpen() {
        if (Shopify.designMode) return;

        if (window.location.pathname.includes('/cart')) return;
        if (window.location.pathname.includes('/checkout')) return;

        let savedData = FoxTheme.utils.getStorage(this.cookieName);
        if (savedData && savedData.opened) return;

        this.trackPageViews();
        this.setupTimeGate();
        this.setupScrollGate();
        this.setupExitIntent();
      }

      trackPageViews() {
        let views = sessionStorage.getItem(this.sessionKey);
        views = views ? parseInt(views) + 1 : 1;

        sessionStorage.setItem(this.sessionKey, views);

        if (views >= 2) {
          this.pageViewedEnough = true;
          this.tryOpen();
        }
      }

      setupTimeGate() {
        setTimeout(() => {
          this.timePassed = true;
          this.tryOpen();
        }, this.minTime);
      }

      setupScrollGate() {
        window.addEventListener('scroll', () => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const docHeight = document.documentElement.scrollHeight - window.innerHeight;

          if (docHeight <= 0) return;

          const progress = scrollTop / docHeight;

          if (progress >= this.scrollPercent) {
            this.scrolledEnough = true;
            this.tryOpen();
          }
        });
      }

      setupExitIntent() {
        if ('ontouchstart' in window) return;

        document.addEventListener('mouseleave', (e) => {
          if (e.clientY <= 0) {
            this.tryOpen(true);
          }
        });
      }

      tryOpen(exitIntent = false) {
        if (this.opened) return;

        if (exitIntent) {
          this.openPopup();
          return;
        }

        if (!this.timePassed) return;

        if (this.scrolledEnough || this.pageViewedEnough) {
          this.openPopup();
        }
      }

      openPopup() {
        if (this.opened) return;

        this.opened = true;

        setTimeout(() => {
          this.show();
        }, 800);
      }

      setRepeatOpen() {
        if (Shopify.designMode) return;

        let expires;

        switch (this.repeatOpen) {
          case 'no_repeat': expires = 365; break;
          case 'every_3_mins': expires = 3 / 60 / 24; break;
          case 'every_5_mins': expires = 5 / 60 / 24; break;
          case 'every_10_mins': expires = 10 / 60 / 24; break;
          case 'every_15_mins': expires = 15 / 60 / 24; break;
          case 'every_30_mins': expires = 30 / 60 / 24; break;
          case 'every_1_hr': expires = 1 / 24; break;
          case 'every_6_hrs': expires = 6 / 24; break;
          case 'every_12_hrs': expires = 0.5; break;
          case 'every_day': expires = 1; break;
          case 'every_3_days': expires = 3; break;
          case 'every_week': expires = 7; break;
          case 'every_2_weeks': expires = 14; break;
          case 'every_month': expires = 30; break;
          default: expires = 7;
        }

        window.FoxTheme.utils.setStorage(this.cookieName, { opened: true }, expires);
      }
    }
  );
}